import React from 'react';
import { SimpleCarousal } from '../../Atoms/Carousel';
import {
  PartnerNextArrow,
  PartnerPrevArrow,
} from '../../partner-pages/partner-carousel/utils';
import SectionHeading from '../common/section-heading-component';
import AwardCard from './award-card';
import { MakingTheHeadlinesSectionProps } from '../types';

const MakingTheHeadlinesSection: React.FC<MakingTheHeadlinesSectionProps> = ({
  awards,
}) => {
  return (
    <section className="py-8 xl:py-24 lg:py-24 md:py-24 wg-container">
      <SectionHeading heading="Making the Headlines" classname="mb-8" />

      <SimpleCarousal
        slidesToShow={4}
        autoplay={true}
        infinite={true}
        slidesToScroll={1}
        arrows={true}
        dots={false}
        mediumScreen={{
          slidesToShow: 3,
        }}
        mobile={{
          dots: false,
          arrows: true,
          centerMode: false,
          slidesToScroll: 1,
          slidesToShow: 1,
          infinite: true,
          autoplay: true,
        }}
        customArrows={{
          customNextArrow: <PartnerNextArrow variant={'topRight'} />,
          customPrevArrow: <PartnerPrevArrow variant={'topRight'} />,
        }}
      >
        {awards.map((award, index) => (
          <AwardCard key={index} card={award} />
        ))}
      </SimpleCarousal>
    </section>
  );
};

export default MakingTheHeadlinesSection;
